import dayjs from 'dayjs'

export const getUrlCode = () => {
  // 截取url中的code方法
  const url = location.href // 获取打开的公众号的路径
  const theRequest = {}
  if (url.indexOf('?') !== -1) {
    const str = url.substring(url.indexOf('?') + 1)
    const strList = str.split('&')
    for (let i = 0; i < strList.length; i++) {
      const items = strList[i].split('=')
      theRequest[strList[i].split('=')[0]] = items[1]
    }
  }
  return theRequest as { code: string }
}

export const formatAvatar = (url: string, size = 100) => {
  if (url?.includes('https://')) {
    return `${url}?imageMogr2/crop/${size}x${size}/gravity/center`
  }
  return '/static/ouyucp/logo.png'
}

export const formatTime = (time: number | string, format = 'YYYY-MM-DD HH:mm:ss') => {
  return dayjs(time).format(format)
}
